/**
 * @generated SignedSource<<9d6d762628006cd2f48a739457c9ef5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutLayout_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutFrame_item" | "CheckoutMobileCancelationPolicy_item" | "CheckoutMobileSummaryNewPane_item" | "CheckoutSidebar_item" | "CheckoutSteps_item" | "useFDFQuoteVariant_item">;
  readonly " $fragmentType": "CheckoutLayout_item";
};
export type CheckoutLayout_item$key = {
  readonly " $data"?: CheckoutLayout_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutLayout_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFDFQuoteVariant_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryNewPane_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebar_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutFrame_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSteps_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileCancelationPolicy_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "81520c566f79799fef4be0f29bb95a3c";

export default node;
